module.exports = __webpack_public_path__ + "static/media/secondBlockBanking@2x.ff7164b3.jpg";